export default {
  default: () => import("/home/runner/work/wdd/wdd/frontend/xaver/layouts/default.vue").then(m => m.default || m),
  registration: () => import("/home/runner/work/wdd/wdd/frontend/xaver/layouts/registration.vue").then(m => m.default || m),
  results: () => import("/home/runner/work/wdd/wdd/frontend/xaver/layouts/results.vue").then(m => m.default || m),
  video: () => import("/home/runner/work/wdd/wdd/frontend/xaver/layouts/video.vue").then(m => m.default || m)
}